import * as React from "react";

import { Field, idMensaje } from "./Field";
import c from "./Control.module.css";

export interface TextareaProps extends React.ComponentPropsWithoutRef<"textarea"> {
  label?: React.ReactNode;
  hint?: React.ReactNode;
  /** Qué pasó y qué hacer. Pinta el borde de rojo y se anuncia como alerta. */
  error?: React.ReactNode;
  /** Muestra "n / máx" a la derecha de la etiqueta; pide `maxLength` y un `value` controlado. Se pone en ámbar al
   *  pasar el 90 %. */
  showCount?: boolean;
}

/** Campo de varias líneas. Crece verticalmente si el usuario lo estira. */
export function Textarea({ label, hint, error, showCount, id, required, className, style, ...rest }: TextareaProps) {
  const generado = React.useId();
  const uid = id ?? generado;
  const largo = typeof rest.value === "string" ? rest.value.length : 0;
  const contador =
    showCount && rest.maxLength ? (
      <span className={c.contador} data-warn={largo > rest.maxLength * 0.9 ? "" : undefined} aria-live="polite">
        {largo} / {rest.maxLength}
      </span>
    ) : null;
  return (
    <Field htmlFor={uid} label={label} hint={hint} error={error} required={required} trailing={contador} className={className} style={style}>
      <span className={c.caja} data-multilinea="" data-error={error ? "" : undefined}>
        <textarea
          id={uid}
          required={required}
          aria-invalid={error ? true : undefined}
          aria-describedby={error || hint ? idMensaje(uid) : undefined}
          className={c.control}
          {...rest}
        />
      </span>
    </Field>
  );
}
